import { combineReducers } from 'redux'
import { reducer as FormReducer } from 'redux-form'
import { default as auth } from './Auth'
import { default as product } from './Product'
import { default as corporate } from './Corporate'

export default combineReducers({
    auth, product, corporate,
    form: FormReducer
})



// WEBPACK FOOTER //
// ./src/ducks/index.js